import './password';

$(document).ready(() => {

  $("#register_layout form").bind('ajax:complete', () => {
    $("#recover_alert").show();
    $("#recover_alert_bkg").show();
    $(document).scrollTop(0);
    $(".devise").css({
      overflow: "hidden",
      height: "100%"
    });

    $("#register_layout").css({
      top: "0",
      position: "absolute",
    });
  })

  function hideAlert() {
    $("#recover_alert").hide();
    $("#recover_alert_bkg").hide();
    $(".devise").css({
      overflow: "",
      height: ""
    });
    $("#register_layout").css({
      top: "",
      position: ""
    });
  }

  $("#recover_alert .btn-primary").click((d) => {
    d.preventDefault();
    hideAlert();
  });

  $("#recover_alert_bkg").click(() => hideAlert());

});
